import React, { useEffect, useState } from 'react';
import './styles.css';
import { Box } from '@material-ui/core';
import ImageUploaderButton from './image-uploader-button';
import ImagesUploaderList from './image-list';
import { useDataProvider } from 'react-admin';
import ImageUploadingField from './image';

interface ImageFile {
  id: string;
  rawFile: File;
}

const CharityImageUploader = (props) => {
  const [images, setImages] = useState<Array<any>>([]);
  const dataProvider = useDataProvider();
  const [image, setImage] = useState<any>({
    id: null,
    url: null,
    localUrl: null,
    isUploading: null,
    file: null,
    Key: null,
  });

  const addImages = async (files) => {
    if (files && files.length) {
      let newImages = [...images];
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        const url = URL.createObjectURL(file);
        if (url) {
          newImages.push({
            id: String(newImages.length + 1),
            url: null,
            localUrl: url,
            isUploading: true,
            file: file,
            Key: null,
          });
        }
      }
      setImages(newImages);
    }
  };
  const selectImage = (files) => {
    if (files && files.length) {
      let newImages = [...images];
      let file = files[0];
      if (file) {
        const url = URL.createObjectURL(file);
        if (url) {
          setImage({
            id: String(newImages.length + 1),
            url: null,
            localUrl: url,
            isUploading: true,
            file: file,
            Key: null,
          });
        }
      }
    }
  };
  const removeImage = async (img) => {
    if (img.error) {
      let imgs = [...images];
      imgs.splice(img.index, 1);
      setImages(imgs);
    } else {
      let response = await dataProvider.deleteBlogAssetsImage(img.Key);
      if (response.data) {
        let imgs = [...images];
        imgs.splice(img.index, 1);
        setImages(imgs);
      }
    }
  };

  async function getImages() {
    try {
      const response = await dataProvider.getBlogAssets();
      let imgs = response.data.list.map((img, index) => {
        return {
          id: img.Key,
          url: `${process.env.REACT_APP_AWS_S3_URL}/${img.Key}`,
          isUploading: false,
          Key: img.Key,
        };
      });
      setImages(imgs);
    } catch (err) {}
  }

  // const uploadImage = async (file) => {
  //   try {
  //     setError('');
  //     console.log('Start uploading image: ', image);
  //     let response = await dataProvider.storeBlogPostAssetsImageAsync([file]);
  //     let url = `${process.env.REACT_APP_AWS_S3_URL}/${response.data[0].url}`;
  //     setImage({
  //       url: url,
  //       id: img.id,
  //       localUrl: img.localUrl,
  //       isUploading: null,
  //       file: null,
  //       Key: response.data[0].url,
  //     });
  //     setIsUploaded(true);
  //   } catch (err: any) {
  //     console.error('Err image uploading: ', JSON.stringify(err));
  //     setError(JSON.stringify(err));
  //     notify(`Err image uploading: ${JSON.stringify(err)}`, 'error');
  //   } finally {
  //     setIsUploading(false);
  //     setIsUploaded(false);
  //   }
  // };

  useEffect(() => {
    // getImages();
    if (props.image.url) {
      setImage({
        url: props.image.url,
        localUrl: props.image.localUrl,
        id: props.image.id,
        file: props.image.file,
      });
    }
  }, []);
  return (
    <Box className='images-uploader'>
      {props.image.id ? (
        <ImageUploadingField
          key={props.image.id}
          id={props.image.id}
          img={props.image}
          onRemove={props.onRemove}
        />
      ) : (
        <ImageUploaderButton onAdd={props.onSelect} label={props.label} />
      )}
    </Box>
  );
};

export default CharityImageUploader;
